import React from 'react';
import './UserStatus.css';

const UserStatus = ({ user, loading, error }) => {
  if (loading) {
    return (
      <div className="user-status loading" role="status" aria-busy="true" aria-label="Loading user status">
        <span className="status-skeleton" aria-hidden="true"></span>
        <span className="status-skeleton status-skeleton--wide" aria-hidden="true"></span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-status error">
        <span className="status-icon">⚠️</span>
        <span className="status-text">Stats unavailable</span>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="user-status anonymous">
        <span className="status-icon">👤</span>
        <span className="status-text">
          Playing as guest - 
          <a 
            href="https://arcade.walterhouse.co.za" 
            target="_blank" 
            rel="noopener noreferrer"
            className="login-link"
          >
            Login at Ashtin's Arcade
          </a> 
          to save progress
        </span>
      </div>
    );
  }

  return (
    <div className="user-status authenticated">
      <span className="status-icon">✅</span>
      <span className="status-text">
        Logged in as {user.displayName || user.username || user.email || 'Arcade player'}
      </span>
    </div>
  );
};

export default UserStatus;
